import { FixedBanner } from '@circlefin/components'
import { getBlockchain } from '@services/static-data/blockchains'
import useTranslation from 'next-translate/useTranslation'

import type { BlockchainAbbreviation } from '@shared/graphql'

export interface AceDepositInfoBannerProps {
  /**
   * Blockchain.
   */
  blockchain?: BlockchainAbbreviation
  /**
   * Custom className.
   */
  className?: string
}

export const AceDepositInfoBanner: React.FC<AceDepositInfoBannerProps> = ({
  blockchain,
  className,
}) => {
  const { t } = useTranslation('ace')
  const { t: tCommon } = useTranslation('common')

  const chain = getBlockchain(blockchain)

  // Only LINEA blockchain has the deposit info banner for now.
  if (chain?.deposits == null) return null

  return (
    <FixedBanner
      className={className}
      data-testid="ace-deposit-info-banner"
      status="info"
    >
      <FixedBanner.Description>
        {t(`alert.aceDepositInfoBanner`, {
          blockchain: chain.name,
          min: chain.deposits.min,
          max: chain.deposits.max,
          duration: tCommon(`duration.${chain.deposits.duration}`),
        })}
      </FixedBanner.Description>
    </FixedBanner>
  )
}
